export default (that) => [
  {
    field: 'seq',
    width: 50,
    align: 'center',
    fixed: 'left',
    type: 'seq',
  },
  {
    field: 'checkbox',
    width: 40,
    align: 'center',
    fixed: 'left',
    type: 'checkbox',
  },
  {
    field: 'defaultImageUrl',
    width: 120,
    title: that.$l('INDEX.table_label_image') || '图片',
    align: 'center',
    fixed: 'left',
    slots: { default: 'defaultImageUrl' },
  },
  {
    title: that.$l('INDEX.table_label_amzSkuNo') || '产品SKU编号',
    field: 'hxSkuNo',
    width: 140,
    fixed: 'left',
    headerAlign: 'center',
    align: 'left',
    showHeaderOverflow: true,
  },
  {
    title: that.$l('INDEX.table_label_ncNo') || 'NC产品编号',
    field: 'ncNo',
    width: 150,
    align: 'center',
    showHeaderOverflow: true,
    showOverflow: true,
  },
  {
    title: that.$l('INDEX.table_label_goodsDevName') || '产品企划名称',
    field: 'goodsDevName',
    width: 300,
    headerAlign: 'center',
    align: 'left',
    showHeaderOverflow: true,
    showOverflow: true,
  },
  {
    title: that.$l('INDEX.table_label_goodsName') || '产品名称',
    field: 'goodsName',
    width: 300,
    headerAlign: 'center',
    align: 'left',
    showHeaderOverflow: true,
    slots: { default: 'displayName' },
  },
  {
    title: that.$l('INDEX.table_label_goodsColor') || '产品颜色',
    field: 'goodsColor',
    minWidth: 200,
    headerAlign: 'center',
    align: 'left',
    showHeaderOverflow: true,
    slots: { default: 'displayColor' },
  },
  {
    title: that.$l('INDEX.table_label_materialInfo') || '材料信息',
    field: 'materialInfo',
    width: 300,
    headerAlign: 'center',
    align: 'left',
    showHeaderOverflow: true,
    showOverflow: true,
  },
  {
    title: that.$l('INDEX.table_label_materialInfoEn') || '英文材料信息',
    field: 'materialInfoEn',
    width: 300,
    headerAlign: 'center',
    align: 'left',
    showHeaderOverflow: true,
    showOverflow: true,
  },
  {
    title: that.$l('INDEX.table_label_brandName') || '品牌名称',
    field: 'brandName',
    width: 200,
    headerAlign: 'center',
    align: 'left',
    showHeaderOverflow: true,
    showOverflow: true,
  },
  {
    title: that.$l('INDEX.table_label_masterCategoryName') || '主分类名称',
    field: 'masterCategoryName',
    width: 200,
    align: 'left',
    showHeaderOverflow: true,
    showOverflow: true,
  },
  {
    title: that.$l('INDEX.table_label_detailCategoryName') || '明细分类名称',
    field: 'detailCategoryName',
    width: 200,
    align: 'left',
    showHeaderOverflow: true,
    showOverflow: true,
  },
  {
    title: that.$l('INDEX.table_label_goodsSize') || '产品尺寸',
    field: 'goodsSize',
    width: 120,
    headerAlign: 'center',
    align: 'left',
    showHeaderOverflow: true,
    showOverflow: true,
  },
  {
    title: that.$l('INDEX.table_label_goodsArea') || '产品面积(㎡)',
    field: 'goodsArea',
    width: 150,
    align: 'center',
    showHeaderOverflow: true,
    showOverflow: true,
  },
  {
    title: that.$l('INDEX.table_label_ftyPrice') || '工厂单价(rmb)',
    field: 'ftyPrice',
    width: 150,
    align: 'center',
    showHeaderOverflow: true,
    showOverflow: true,
  },
  {
    title: that.$l('INDEX.table_label_salesPrice') || '建议售价(rmb)',
    field: 'salesPrice',
    width: 150,
    align: 'center',
    showHeaderOverflow: true,
    showOverflow: true,
  },


  {
    title: that.$l('INDEX.table_label_scmName') || '工厂名称',
    field: 'scmName',
    width: 200,
    headerAlign: 'center',
    align: 'left',
    showHeaderOverflow: true,
    showOverflow: true,
  },
  {
    title: that.$l('INDEX.table_label_goodsWeight') || '单品重量(kg)',
    field: 'goodsWeight',
    width: 150,
    align: 'center',
    showHeaderOverflow: true,
    showOverflow: true,
  },
  {
    title: that.$l('INDEX.table_label_unitLength') || '单品包装长(cm)',
    field: 'unitLength',
    width: 150,
    align: 'center',
    showHeaderOverflow: true,
    showOverflow: true,
  },
  {
    title: that.$l('INDEX.table_label_unitWidth') || '单品包装宽(cm)',
    field: 'unitWidth',
    width: 150,
    align: 'center',
    showHeaderOverflow: true,
    showOverflow: true,
  },
  {
    title: that.$l('INDEX.table_label_unitHeight') || '单品包装高(cm)',
    field: 'unitHeight',
    width: 150,
    align: 'center',
    showHeaderOverflow: true,
    showOverflow: true,
  },
  {
    title: that.$l('INDEX.table_label_unitWeight') || '单品包装重量(kg)',
    field: 'unitWeight',
    width: 150,
    align: 'center',
    showHeaderOverflow: true,
    showOverflow: true,
  },
  {
    title: that.$l('INDEX.table_label_unitCbm') || '单品包装体积(m³)',
    field: 'unitCbm',
    width: 150,
    align: 'center',
    showHeaderOverflow: true,
    showOverflow: true,
  },
  {
    title: that.$l('INDEX.table_label_inCtnQty') || '装箱入数',
    field: 'inCtnQty',
    width: 150,
    align: 'center',
    showHeaderOverflow: true,
    showOverflow: true,
  },
  {
    title: that.$l('INDEX.table_label_ctnLength') || '纸箱长(cm)',
    field: 'ctnLength',
    width: 150,
    align: 'center',
    showHeaderOverflow: true,
    showOverflow: true,
  },
  {
    title: that.$l('INDEX.table_label_ctnWidth') || '纸箱宽(cm)',
    field: 'ctnWidth',
    width: 150,
    align: 'center',
    showHeaderOverflow: true,
    showOverflow: true,
  },
  {
    title: that.$l('INDEX.table_label_ctnHeight') || '纸箱高(cm)',
    field: 'ctnHeight',
    width: 150,
    align: 'center',
    showHeaderOverflow: true,
    showOverflow: true,
  },
  {
    title: that.$l('INDEX.table_label_ctnCbm') || '纸箱体积(m³)',
    field: 'ctnCbm',
    width: 150,
    align: 'center',
    showHeaderOverflow: true,
    showOverflow: true,
  },
  {
    title: that.$l('INDEX.table_label_ctnGrossWeight') || '箱毛重(kg)',
    field: 'ctnGrossWeight',
    width: 150,
    align: 'center',
    showHeaderOverflow: true,
    showOverflow: true,
  },
  {
    title: that.$l('INDEX.table_label_ctnNetWeight') || '箱净重(kg)',
    field: 'ctnNetWeight',
    width: 150,
    align: 'center',
    showHeaderOverflow: true,
    showOverflow: true,
  },
  {
    title: that.$l('INDEX.table_label_goodsProperties') || '产品属性',
    field: 'goodsProperties',
    width: 200,
    headerAlign: 'center',
    align: 'left',
    showHeaderOverflow: true,
    showOverflow: true,
  },
  {
    title: that.$l('INDEX.table_label_designName') || '企划人员',
    field: 'designName',
    width: 160,
    align: 'center',
    showHeaderOverflow: true,
    showOverflow: true,
  },
  {
    title: that.$l('INDEX.table_label_buyerName') || '采购人员',
    field: 'buyerName',
    width: 160,
    align: 'center',
    showHeaderOverflow: true,
    showOverflow: true,
  },
  {
    title: that.$l('INDEX.creator') || '创建人',
    field: 'createByName',
    width: 170,
    headerAlign: 'center',
    align: 'left',
    showHeaderOverflow: true,
    slots: { default: 'createInfo' },
  },
  {
    title: that.$l('INDEX.table_label_modified_by') || '修改人',
    field: 'modifyByName',
    width: 170,
    headerAlign: 'center',
    align: 'left',
    showHeaderOverflow: true,
    slots: { default: 'modifyInfo' },
  },
]
